import { createContext } from "react";
import { KnopReactApp } from "./reactApp";

export const ReactAppContext = createContext<KnopReactApp | undefined>(undefined);
